import { InjectionToken } from '@angular/core';
import { Translations } from '../../types/translation.type';

export const TRANSLATIONS_TOKEN = new InjectionToken<Translations[]>('translations');
